import { render, staticRenderFns } from "./AudioPlay.vue?vue&type=template&id=1fa2e73c&scoped=true"
import script from "./AudioPlay.vue?vue&type=script&lang=js"
export * from "./AudioPlay.vue?vue&type=script&lang=js"
import style0 from "./AudioPlay.vue?vue&type=style&index=0&id=1fa2e73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa2e73c",
  null
  
)

export default component.exports